import React, { FC, ReactNode } from 'react'
import '../icon.scss'

export const TimeHorizonNeutralIcon: FC<ReactNode> = () => {
  return (
    <div className='icon-container' data-testid='time-horizon-neutral-icon'>
      <img
        src={
          'https://www.static-immobilienscout24.de/statpic/sales-journey/hos/rle-wizard/icons/60e3f63f1b95e744ad8296880ea5716d_IS24_PleaseBePatient_neutral.png'
        }
        width={128}
        height={128}
        alt={''}
      />
    </div>
  )
}
